import { genericPlayerParser } from '../commonInbounds/utils/genericPlayerInboundUtils';
import { encodedStringParser } from '../inboundParsers';
export const ENTER_MTT_STAGING_PLAYER_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'player', parser: genericPlayerParser },
        { name: 'enterMessage', parser: encodedStringParser }
    ]
};
